// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__Xi0aO","checkmark":"checkbox_checkmark__7oyyO","radio":"checkbox_radio__bH_0A"};